import { useCallback } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import FullScreenModalFooter from "ds/components/FullScreenModal/Footer";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { ArrowLeft } from "components/icons/generated";

import { ApiKeyCreateWizardContext } from "../context";

type ApiKeyCreateFooterProps = {
  onCreateClick?: () => void;
  runFormValidations?: () => Promise<boolean>;
  loading?: boolean;
};

const ApiKeyCreateFooter = ({
  onCreateClick,
  runFormValidations = async () => true,
  loading = false,
}: ApiKeyCreateFooterProps) => {
  const { isFirstStep, isLastStep, goToNextStep, goToPreviousStep } =
    useTypedContext(ApiKeyCreateWizardContext);

  const handleContinueClick = useCallback(async () => {
    const isValid = await runFormValidations();
    if (isValid) {
      goToNextStep();
    }
  }, [runFormValidations, goToNextStep]);

  return (
    <FullScreenModalFooter justify="between">
      <DocumentationIconButton
        href={getDocsUrl("/integrations/api#spacelift-api-key")}
        tooltipText="Go to API keys documentation"
      />
      <Box direction="row" gap="large">
        {!isFirstStep && (
          <Button startIcon={ArrowLeft} variant="secondary" onPress={goToPreviousStep}>
            Back
          </Button>
        )}
        {!isLastStep && (
          <Button variant="primary" onPress={handleContinueClick}>
            Continue
          </Button>
        )}
        {isLastStep && onCreateClick && (
          <Button variant="primary" onPress={onCreateClick} loading={loading}>
            Create API key
          </Button>
        )}
      </Box>
    </FullScreenModalFooter>
  );
};

export default ApiKeyCreateFooter;
